import { ref as o, onMounted as t } from "vue";
const e = o(!1), d = () => {
  e.value = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}, n = () => (t(() => {
  d();
}), e);
export {
  d as detectReducedMotionMode,
  e as isReducedMotion,
  n as useReducedMotion
};
